/**
 * FmsModFunc
 */
import moment from 'moment';
import { addDays, compareIso, formatDate, getCurrentDateIso, jsDateToIso, now, nowDate } from '../../dateUtils';
import {SQLField, SQLInfo, SQLType} from '../../framework.core/data/SQLInfo';
import { JobNames } from '../../framework.core/JobNames';
import { getFmsGlobal } from '../../globals';
import { checkCompleteBLForm, SaveNewJournalByMaster, setStatusAll } from './FmsModAccount';
import { isNullOrEmpty } from './../../util/index';

export function historyUpdate(tbName:string, tbId:number, userID:string, msg:string = "", title:string = "Update History", skipSuntekAdmin:boolean = true):SQLInfo|null {
  if(skipSuntekAdmin && (userID === getFmsGlobal().SUNTEK_ID || userID.startsWith('@'))) return null;
  
  const result = new SQLInfo();
  result.type = SQLType.InsertOrUpdate;
  result.tableName = SQLInfo.UpdateHistory;
  result.whereFields = [
    new SQLField({ fieldName: "f_tbname", propertyName: "tbName", value: tbName }),
    new SQLField({ fieldName: "f_tbid", propertyName: "tbid", value: tbId }),
    new SQLField({ fieldName: "f_title", propertyName: "title", value: title }),    
  ];

  let contents = "";
  if(tbId <= 0) {
    // new
    if(!msg) msg = "ADD";
    contents = `${msg} BY ${userID}`;
  } else {
    if(!msg) msg = "EDIT";
    contents = `${msg} BY ${userID}`;
  }
  result.fields.push(new SQLField({ fieldName: "f_contents", propertyName:"contents", value: contents}));
  return result;
}

//231123 Draft이고 msg가 공백("")일 때만 의미 있음
export function acctHistoryUpdate(tbName: string, tbId: number, userID: string, msg: string = "", isDraft: boolean | undefined, title: string = "Update History", skipSuntekAdmin: boolean = true): SQLInfo | null {
  let histMsg = '';
  //let contents = '';
  if (!msg) {
    if (isDraft) {
      if (tbId <= 0) {
        histMsg = "ADD DRAFT";
        //contents = `${msg} DRAFT BY ${userID}`;
      } else {
        histMsg = "EDIT DRAFT";
        //contents = `${msg} DRAFT BY ${userID}`;
      }
    }
  }
  return historyUpdate(tbName, tbId, userID, histMsg, title, skipSuntekAdmin);
}

export function saveDutyEntity(jobName:string, jobId:number, dutyCustId:number, dutyAgentId:number, mblJobName:string, mblJobId:string):SQLInfo {
  return new SQLInfo({
    tableName: SQLInfo.UpdateDutyEntity,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: "f_dutyentity", propertyName: "dutyEntityId", value: dutyCustId}),
      new SQLField({ fieldName: "f_dutyagent", propertyName: "dutyAgentId", value: dutyAgentId}),
    ],
    whereFields: [
      new SQLField({ fieldName: "", propertyName: "jobName", value: jobName}),
      new SQLField({ fieldName: "", propertyName: "jobId", value: jobId}),
      new SQLField({ fieldName: "", propertyName: "mblJobName", value: mblJobName}),
      new SQLField({ fieldName: "", propertyName: "mblJobId", value: mblJobId}),
    ]
  });
}

export function updateHCFS(jobName:JobNames, jobId:number, cfsLocation:number):SQLInfo|null {
  if(cfsLocation <= 0 || jobId <= 0|| [JobNames.OIMbl, JobNames.AIMbl].indexOf(jobName) < 0) return null;
  return new SQLInfo({
    tableName: jobName === JobNames.OIMbl ? 'T_OIHMAIN' : 'T_AIHMAIN',
    type: SQLType.Update,
    fields: [ new SQLField({ fieldName: "F_CFSLocation", propertyName: "cfsLocation", value: cfsLocation }) ],
    whereFields: [ new SQLField({ fieldName: jobName === JobNames.OIMbl ? "F_OIMBLID" : "F_AIMBLID", propertyName: "mblId", value: jobId })]
  });
}

export function updateBLStatus(jobName:string, jobId:number, updateHouse:boolean = false):SQLInfo {
  return new SQLInfo({
    tableName: SQLInfo.BlStatus,
    type: SQLType.Execute,
    whereFields: [
      new SQLField({ fieldName: "", propertyName: "jobName", value: jobName }),
      new SQLField({ fieldName: "", propertyName: "jobId", value: jobId }),
      new SQLField({ fieldName: "", propertyName: "updateHouse", value: updateHouse }),
    ]
  });
}

//<pt211227: Move to dateUtil>
// export function getBigDate(date1:string|null, date2:string|null):string|null {
//   if(!date1) {
//     if(!date2) return null;
//     else return date2;
//   }
//   else if(!date2)
//     return date1;
//   else {
//     const fmsGlobal = getFmsGlobal();
//     const d1 = moment(date1, moment.ISO_8601).isValid() ? moment(date1) : moment(date1, fmsGlobal.DateFormat);
//     const d2 = moment(date2, moment.ISO_8601).isValid() ? moment(date2) : moment(date2, fmsGlobal.DateFormat);
//     return d1 > d2 ? date1 : date2;
//   }
// }

export function getFieldValue(sid:string, sTableName:string, sFieldName:string, sIDFieldName:string = "F_ID", sFieldName2:string = "") {

}

export function getDepartmentNameByTbName(tbName: string){
  let result = "";
  switch(tbName){
    case "T_OIMMAIN": 
      result = 'Ocean Import Master'; 
      break;
    case "T_OIHMAIN": 
      result = 'Ocean Import House'; 
      break; 
    case "T_OOMMAIN": 
      result = 'Ocean Export Master'; 
      break;
    case "T_OOHMAIN":  
      result = 'Ocean Export House'; 
      break;
    case "T_AIMMAIN": 
      result = 'Air Import Master'; 
      break;
    case "T_AIHMAIN": 
      result = 'Air Import House'; 
      break;
    case "T_AOMMAIN": 
      result = 'Air Export Master'; 
      break;
    case "T_AOHMAIN": 
      result = 'Air Export House'; 
      break;
    case "T_GENMAIN": 
      result = 'Other Operation'; 
      break;
    case "T_WRECEIVEHD": 
      result = 'Receiving'; 
      break;
    case "T_WSHIPHD": 
      result = 'Shipping'; 
      break;
  }
  return result;
}

export function getSelectedCheckValues(items: string[], seperator: string){
  let result = "";
  items.forEach(val => {
    if(val.length > 0){
      result += (result.length > 0 ? seperator : "") + val;
    }
  });
  return result;
}

export function isValidFYDate(isoDate: string, endMonth:number) {
  let result = false;
  if(isoDate) {
    let fyEnd = new Date();
    fyEnd.setFullYear(fyEnd.getFullYear() + 1);
    fyEnd.setMonth(endMonth === 12 ? 0 : endMonth);
    fyEnd.setDate(1);

    if(endMonth === 12 || endMonth < ((new Date()).getMonth() + 1))
      fyEnd.setFullYear(fyEnd.getFullYear() + 1);

    const fyisoEnd = addDays(jsDateToIso(fyEnd), -1);
    if(compareIso(isoDate, fyisoEnd) <= 0) {
      result = true;
    }
  }
  return result;
}

/**
 * Determine if checkNo is prohibited word
 * @param checkNo 
 * @returns true for prohibited, false for ok to use
 */
export function checkBillNo(checkNo:string):boolean {
  const fmsGlobal = getFmsGlobal();  
  if(!fmsGlobal.bannedWords || fmsGlobal.bannedWords.length === 0) {
    return false;
  }
  else {
    return  fmsGlobal.bannedWords.indexOf(checkNo.toUpperCase()) >= 0;
  }
}

/**
 * Caller: BillView
 * @param tbType 
 * @param depoId 
 * @param originId 
 * @param creditAmt 
 */
export function deleteDepoData(tbType:string, depoId:number, originId:number, creditAmt:number) {
  return new SQLInfo({
    tableName: SQLInfo.DeleteDepoData,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: '', propertyName: 'tbType', value: tbType}),
      new SQLField({ fieldName: '', propertyName: 'deopId', value: depoId}),
      new SQLField({ fieldName: '', propertyName: 'originId', value: originId}),
      new SQLField({ fieldName: '', propertyName: 'creditAmt', value: creditAmt}),
    ]
  });
}

/**
 * Check inputDate's validity for fieldName and return '' (ok) or error msg
 * @param inputDate 
 * @param initDate 
 * @param fieldName 
 */
export function checkPostDate(inputDate:string|null, initDate:string|null, fieldName:string):string {
  const result = `Invalid ${fieldName}.`;
  if(!inputDate || !initDate) {
    return result;
  }

  const today = getCurrentDateIso();
  if(compareIso(inputDate, today) > 0) {
    if(compareIso(inputDate, initDate) !== 0) {
      return result;
    }
  } else if(compareIso(initDate, inputDate) > 0 || compareIso(today, inputDate) < 0) {
    return result;
  }
  return '';
}

/**
 * Check input date compared to today and closedate
 * @param inputDate 
 * @param initDate 
 * @param fieldName 
 * @returns 
 */
export function checkPostDate2(inputDate:string, initDate:string, fieldName:string):string {
  const today = getCurrentDateIso();
  const fmsGlobal = getFmsGlobal();
  if(compareIso(initDate, today) > 0) {
    if(compareIso(inputDate, initDate) !== 0) {
      return `${fieldName} Date cannot exceed today`;
    }
  } else if(fmsGlobal.CloseDate && (compareIso(inputDate, initDate) < 0 || compareIso(today, inputDate) < 0)) {
    return `${fieldName} Date must be between Closed Date + 1 (${formatDate(addDays(fmsGlobal.CloseDate, 1))}) and Today`
  }
  return '';
}

/**
 * CloseDate와 AcctStartDate중 큰 날짜와 비교하여 vDate가 나중이면 vDate,
 *  이 전이면 큰날짜 다음 날이 glDate로 반환된다.
 * @param vDate
 * @param startDateYear
 * @param startDateMonth
 */
export function getGLDate(vDate: string | null, startDateYear: string, startDateMonth: string, returnDate: string = '') {
  if (vDate === null) return vDate;
  let closeData = null;
  let glDate = null;
  const fmsGlobal = getFmsGlobal();
  const tempDate = new Date(parseInt(startDateYear), parseInt(startDateMonth) - 1, 1).toString();
  const AcctStartDate = addDays(tempDate, -1);

  if (fmsGlobal.CloseDate) {
    closeData = fmsGlobal.CloseDate < AcctStartDate ? AcctStartDate : fmsGlobal.CloseDate;
  }

  if (closeData) {
    if (returnDate) {
      glDate = closeData < vDate ? vDate : returnDate; 
    }
    else {
      glDate = closeData < vDate ? vDate : addDays(closeData, 1);
    }
  } else {
    glDate = vDate;
  }
  
  if (!glDate) glDate = nowDate();

  return glDate;
}

export function updateOriginActionDate(tbName:string, originId:string, newId:string) {
  return new SQLInfo({
    tableName: tbName,
    type: SQLType.Update,
    fields: [
      new SQLField({ fieldName: "f_u2date", propertyName:"@@tsql", value: `(SELECT F_U1Date FROM ${tbName} WHERE F_ID = ${newId} )`}),
      new SQLField({ fieldName: "f_u2id", propertyName:"@@tsql", value: `(SELECT F_U1ID FROM ${tbName} WHERE F_ID = ${newId})`})
    ],
    where: 'f_id=' + originId
  });
}

export function finalizeHistoryUpdate(recogDate:string, tbName:string, tbId:number, userId:string, hTbId:number = 0, isSet:boolean = true): SQLInfo[] | null {
  let sqlInfo: SQLInfo|null;
  const sqlInfos: SQLInfo[] = [];
  const msg = (isSet ? `Recog on [${formatDate(recogDate)}]` : 'Undo Recog');

  if (hTbId > 0) {
    if (tbName === "T_BTORDER") 
      sqlInfo = historyUpdate("T_BTLOAD", tbId, userId, msg);  // Master : Orchid
    else 
      sqlInfo = historyUpdate(tbName.replace('H','M'), tbId, userId, msg);  // Master : B/L
    if (sqlInfo) sqlInfos.push(sqlInfo);
    sqlInfo = historyUpdate(tbName, hTbId, userId, msg);  // House
    if (sqlInfo) sqlInfos.push(sqlInfo);
  } else {
    sqlInfo = historyUpdate(tbName, tbId, userId, msg);
    if (sqlInfo) sqlInfos.push(sqlInfo);
  }

  if(sqlInfos.length === 0) return null;
  else return sqlInfos;
}

export function getRecogConfirmMsg(recogDate:string, beforeClosing:boolean = false, isSet:boolean): any {
  const result = { errorMsg: "", confirmMsg: "This Action will Recog M/H BL Sales, Cost and Cr/Db Note.\r\n" };
  const defaultDate = moment(new Date(2000, 0, 1)).format();

  if (isSet) {
    if(compareIso(recogDate, defaultDate) <= 0) {
      result.errorMsg = "Have some problem to read database. Please try later.";
      return result;
    } 
  //   else if(compareIso(recogDate, now()) > 0) {
  //     result.errorMsg = 
  //     `Recog Date is future date or
  // There remains Invoice/Bill/CrDb to be created.
  // It is not allowed to RECOG.`
  //     return result;
  //   }

    // if(beforeClosing) {
    //   result.confirmMsg += `date will be the day after closing date. (${formatDate(recogDate)})\r\nContinue to RECOG ?`
    // } else {
    //   result.confirmMsg += "Continue to RECOG ?"
    // }
  } 
  // else 
  //   result.confirmMsg = "Do you want to Undo RECOG. ?";

  return result;
}

export function getRecogSQLInfos(mTbName:string, mTbId:number, recogDate:string, userId:string, isSet:boolean) {
  let sqlInfo: SQLInfo|null;
  let sqlInfos: SQLInfo[]|null;
  let sqlInfoList: SQLInfo[] = [];

  sqlInfos = setStatusAll(mTbName, mTbId, isSet);
  if(sqlInfos) sqlInfoList.push(...sqlInfos);
  sqlInfo = checkCompleteBLForm(mTbName, mTbId, recogDate, userId, isSet);
  if(sqlInfo) sqlInfoList.push(sqlInfo);
  sqlInfos = finalizeHistoryUpdate(recogDate, mTbName, mTbId, userId, 0, isSet);
  if(sqlInfos) sqlInfoList.push(...sqlInfos);
  sqlInfo = SaveNewJournalByMaster(mTbName, mTbId, userId);
  if(sqlInfo) sqlInfoList.push(sqlInfo);

  return sqlInfoList;
}

export function getISOCodeFromSuntekSetup(country:string){
  let iso = '';

  switch (country)
  {
      case "U.S.": iso = "US"; break;
      case "U.K.": iso = "GB"; break;
      case "SINGAPORE": iso = "SG"; break;
      case "PUERTO RICO": iso = "PR"; break;
      case "PANAMA": iso = "PA"; break;
      case "MEXICO": iso = "MX"; break;
      case "KOREA": iso = "KR"; break;
      case "JAPAN": iso = "JP"; break;
      case "CHINA": iso = "CN"; break;
      //case "TAIWAN": iso = "TW"; break; // Suntek Setup에 없는 Country
      case "CANADA": iso = "CA"; break;
      case "CHILE": iso = "CL"; break;
      case "FRANCE": iso = "FR"; break;
      //case "GERMANY": iso = ""; break; // VB에서도 GERMANY가 존재하지 않음.
      case "GUATEMALA": iso = "GT"; break;
      case "ITALY": iso = "IT"; break;
      default: iso = "US"; break;
  }

  return iso;

}

export function setDefaultForMSetup(fmsMAccountOpt: any) {
  if (fmsMAccountOpt == null) return null;

  if (isNullOrEmpty(fmsMAccountOpt.invoDefaultDateForImport)) fmsMAccountOpt.invoDefaultDateForImport = "TODAY";
  if (isNullOrEmpty(fmsMAccountOpt.invoDefaultDateForExport)) fmsMAccountOpt.invoDefaultDateForExport = "TODAY";
  if (isNullOrEmpty(fmsMAccountOpt.billDefaultDateForImport)) fmsMAccountOpt.billDefaultDateForImport = "TODAY";
  if (isNullOrEmpty(fmsMAccountOpt.billDefaultDateForExport)) fmsMAccountOpt.billDefaultDateForExport = "TODAY";
  if (isNullOrEmpty(fmsMAccountOpt.crDbDefaultDateForImport))
  {
      if (fmsMAccountOpt.useETACrDb) 
        fmsMAccountOpt.crDbDefaultDateForImport = "FETA/ETA";
      else
      {
          if (fmsMAccountOpt.useTodayCrDbDefaultDate)
              fmsMAccountOpt.crDbDefaultDateForImport = "TODAY";
          else
          fmsMAccountOpt.crDbDefaultDateForImport = "ETD";
      }
  }
  if (isNullOrEmpty(fmsMAccountOpt.crDbDefaultDateForExport))
  {
      if (fmsMAccountOpt.useTodayCrDbDefaultDate) fmsMAccountOpt.crDbDefaultDateForExport = "TODAY";
      else fmsMAccountOpt.crDbDefaultDateForExport = "ETD";
  }

  return fmsMAccountOpt;
}

